__turbopack_context__.v({
  "item": "landing-navigation-module-scss-module__bddn8q__item",
  "label": "landing-navigation-module-scss-module__bddn8q__label",
  "root": "landing-navigation-module-scss-module__bddn8q__root",
  "separator": "landing-navigation-module-scss-module__bddn8q__separator",
});
